/**
 * withSkus
 * HOC for wrapping the provided component with SkusProvider
 */

import React from 'react'

import SkusProvider from './skus-provider'

export default function withSkus (WrappedComponent) {
  return function SkusProviderHOC(props) {
    return (
      <SkusProvider>
        <WrappedComponent {...props} />
      </SkusProvider>
    )
  }
}
